import { render } from "./SearchCard.vue?vue&type=template&id=0a3d61b2&scoped=true"
import script from "./SearchCard.vue?vue&type=script&lang=js"
export * from "./SearchCard.vue?vue&type=script&lang=js"

import "./SearchCard.vue?vue&type=style&index=0&id=0a3d61b2&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3d61b2"]])

export default __exports__